<template>
  <div>
    <Loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true" />

    <QuestionsInfo
      :questionIndex="questionIndex"
      @finish="createQuestionnaire" />

    <div class="main-center">
      <div class="container container-mid">
        <Carousel
          ref="carousel"
          :per-page="1"
          :navigate-to="questionIndex"
          :mouse-drag="false"
          :touch-drag="false"
          :pagination-enabled="false"
          :adjustableHeight="true"
          :speed="350">
          <Slide
            v-for="(question, index) in questions"
            :key="index">
            <div class="question">
              <ValidateMessage
                :error="validateErrors[`questions.${index}.answer`]" />
              <ValidateMessage
                :error="validateErrors[`questions.${index}.answers`]" />
              <ValidateMessage
                :error="validateErrors[`questions.${index}.answer_media_id`]" />

              <div
                v-if="question.required"
                class="mb-3">
                <span class="badge badge-pill badge-light">Resposta obrigatória</span>
              </div>
              <div class="mb-4">
                  <div class="question-label">{{ question.label }}</div>
                  <div
                    v-if="question.image_media_id"
                    class="mt-3 question-image">
                    <img
                      :src="imageResizeUrl + encodeURIComponent(question.image_media_id.url)"
                      @load="resizeCarousel" />
                  </div>
              </div>

              <InputText
                v-if="question.type === 'text'"
                v-model="question.answer" />
              <Textarea
                v-if="question.type === 'textarea'"
                v-model="question.answer" />
              <Radio
                v-if="question.type === 'radio'"
                v-model="question.answer"
                :options="question.options" />
              <Checkbox
                v-if="question.type === 'checkbox'"
                v-model="question.answers"
                :options="question.options" />
              <Mostleast
                v-if="question.type === 'mostleast'"
                v-model="question.answers"
                :options="question.options" />
              <File
                v-if="question.type === 'file'"
                v-model="question.answer_media_id" />
            </div>
          </Slide>
        </Carousel>
      </div>
    </div>

    <QuestionsNav
      :questionIndex="questionIndex"
      @goTo="goTo"
      @finish="createQuestionnaire" />
  </div>
</template>

<script>
import config from '@/config'
import InputText from '../components/Fields/InputText'
import Textarea from '../components/Fields/Textarea'
import Radio from '../components/Fields/Radio'
import Checkbox from '../components/Fields/Checkbox'
import Mostleast from '../components/Fields/Mostleast'
import File from '../components/Fields/File'
import QuestionsNav from '../components/QuestionsNav'
import QuestionsInfo from '../components/QuestionsInfo'
import ValidateMessage from '../components/ValidateMessage'
import { Carousel, Slide } from 'vue-carousel'
import Loading from 'vue-loading-overlay'

export default {
  name: 'BarHeader',
  components: {
    InputText,
    Textarea,
    Radio,
    Checkbox,
    Mostleast,
    File,
    QuestionsNav,
    QuestionsInfo,
    ValidateMessage,
    Carousel,
    Slide,
    Loading
  },
  data () {
    return {
      loading: false,
      questions: JSON.parse(JSON.stringify(this.$store.getters.getQuestionnaire.questions)),
      questionIndex: 0,
      validateErrors: {}
    }
  },
  computed: {
    questionnaire () {
      return this.$store.getters.getQuestionnaire
    },
    token () {
      return this.$store.getters.getToken
    },
    imageResizeUrl () {
      return `${config.modfile_url}/image/520x520x0/`
    }
  },
  mounted () {
    this.goTo(0)
  },
  methods: {
    goTo (index = 0) {
      if (index >= 0 && index < this.questions.length) {
        this.questionIndex = Number(index)
        this.$set(this.questions[index], 'viewed', true)
        this.$store.dispatch('changeQuestionnaire', { questions: this.questions })
        document.querySelector('.main-center').scrollIntoView() // return to top scroll
      }
    },
    printValidateErrors () {
      const errors = this.validateErrors
      const fieldError = Object.keys(errors).find(value => value.startsWith('questions.'))

      if (fieldError) {
        const index = fieldError.split('.')[1]
        this.goTo(index)
      }
    },
    createQuestionnaire () {
      this.loading = true

      this.$store
      .dispatch('createQuestionnaire', this.questionnaire)
      .then((result) => {
        this.loading = false
        this.$router.push({ path: `/${this.token}/finish` })
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
          this.printValidateErrors()
        }
      })
    },
    resizeCarousel () {
      this.$refs.carousel.computeCarouselHeight()
    }
  }
}
</script>

<style scoped>
.main-center {
  padding-top: 6em;
  padding-bottom: 6em;
}
.badge-light {
  font-size: 0.8rem;
}
</style>
